import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Confirmation from '../components';
import { hotelReservationSelector } from '../selectors';
import { propertySelector } from 'routes/DateSelection/selectors';
import { selectedRoomSelector } from 'routes/ChooseAccommodation/selectors';
import {
  numberOfGuestsSelector,
  isWaitListBookingSelector
} from 'routes/DateSelection/selectors';
import {
  guestInfoSelector,
  reviewAndSubmitFormSelector
} from 'routes/ReviewAndSubmit/selectors';
import { resetApp } from 'reducers';

const mapStateToProps = createStructuredSelector({
  hotelReservation: hotelReservationSelector,
  property: propertySelector,
  selectedRoom: selectedRoomSelector,
  numberOfGuests: numberOfGuestsSelector,
  guestInfo: guestInfoSelector,
  reviewAndSubmitForm: reviewAndSubmitFormSelector,
  isWaitListBooking: isWaitListBookingSelector
});

function mapDispatchToProps(dispatch) {
  return {
    resetApp: () => dispatch(resetApp())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Confirmation);
